var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"page-header"},[_vm._v(" Мои авто ")]),_c('AppCarList',{attrs:{"cars":_vm.cars}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }